import cns from 'classnames';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { Row } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { RuntimeContext } from '../../../../common/RuntimeContext';
import VerbButton, { VERB_BUTTON_TYPE } from '../VerbButton';

import { hideModal } from '../../actions/index';
import FormFeedback from '../formComponents/FormFeedback';
import BasicTextArea from '../formComponents/groups/BasicTextArea';
import BasicToggle from '../formComponents/groups/BasicToggle';
import VerbText from '../VerbText';

class InviteEmployees extends Component {
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        submitting: PropTypes.bool.isRequired,
        hideModal: PropTypes.func,
        failMsg: PropTypes.any,
        companyPermalink: PropTypes.string,
        enableInviteByEmail: PropTypes.bool,
        className: PropTypes.string,
        isVerbAdmin: PropTypes.bool
    };

    static contextType = RuntimeContext

    constructor(props) {
        super(props);

        this.state = {
            copied: false,
            inviteSuccessMsg: 'Success!'
        };
    }

    componentWillUnmount() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }

    cancelOrClose = () => {
        this.props.hideModal();
    };

    handleFocus = (event) => {
        event.target.select();
    };

    onCopy = () => {
        this.setState({ copied: true });
        this.timeoutId = setTimeout(() => {
            this.setState({ copied: false });
        }, 3000);
    };

    render() {
        const {
            submitting,
            failMsg,
            companyPermalink = '',
            handleSubmit,
            enableInviteByEmail,
            className,
            isVerbAdmin
        } = this.props;

        let companyPermalinkSection = null;
        if (companyPermalink && isVerbAdmin) {

            companyPermalinkSection = (
                <div className={'col-12 inviteEmployeesForm-permalink'}>
                    <p className={'inviteEmployeesForm-link-instructions'}>
                        {enableInviteByEmail
                            ? `OR send this link to your team to let them sign up with their email address:`
                            : `Send this link to your team to let them sign up with their email address:`}
                    </p>
                   
                    <Row className={'col-12'}>
                        <span className={cns({ invisible: !this.state.copied })}>
                            <VerbText
                                messageId={'INVITE_LINK_COPIED_CONFIRMATION'}
                                defaultMessage={'Link copied to clipboard!'}
                            />
                        </span>
                    </Row>
                </div>
            );
        }

        return (
            <form className={`inviteEmployeesForm ${className}`}>
                {enableInviteByEmail && (
                    <Field
                        name={'emails'}
                        labelTextId={'INVITE_EMAILS_LABEL'}
                        labelDefault={'Emails'}
                        className={'col-12'}
                        placeholderTextId={'INVITE_EMAIL_PLACEHOLDER_TEXT'}
                        component={BasicTextArea}
                        labelClassName={'inviteEmployeesForm-email'}
                        styleProps={{ horizontal: true }}
                    />
                )}
                {companyPermalinkSection}
                {isVerbAdmin && enableInviteByEmail && (
                    <Field
                        name={'inviteAsCompanyAdmin'}
                        className={'col-12 inviteEmployees-comp-admin'}
                        label={'Company Admin'}
                        component={BasicToggle}
                        description={`Sets whether user(s) being invited receive company admin permissions after registering. If toggled off, will default to learner permissions`}
                        companyForm={true}
                        inputClassName={'company-admin-toggle'}
                        styleProps={{ horizontal: true, labelClass: 'col-12 col-sm-8 no-padding' }}
                        id={'invite-as-company-admin-toggle'}
                    />
                )}
                <div className={'row'}>
                    <div className={'col-sm-12 buttons-container'}>
                        {enableInviteByEmail && (
                            <VerbButton
                                className={'inviteEmployeesForm-submit'}
                                onClick={(values) =>
                                    handleSubmit(values).then((successMsg) => this.setState(successMsg))
                                }
                                disabled={submitting}
                                textId={'BUTTON_INVITE_EMPLOYEES'}
                                defaultMessage={'INVITE EMPLOYEES'}
                            />
                        )}
                        <VerbButton
                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                            onClick={this.cancelOrClose}
                            disabled={submitting}
                            textId={'BUTTON_CLOSE'}
                            defaultMessage={'ClOSE'}
                        />
                    </div>
                </div>
                <FormFeedback
                    {...this.props}
                    submittingMsg={'Sending...'}
                    className={'col-12 form-feedback'}
                    failMsg={failMsg}
                    successMsg={this.state.inviteSuccessMsg}
                />
            </form>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    hideModal: () => dispatch(hideModal())
});

export const InviteEmployeesComponent = InviteEmployees;

const InviteEmployeesValidation = {
    form: 'Invite',
    validate: (values) => {
        const errors = {};
        if (!values.emails) {
            errors.emails = 'At least one email required';
        }
        return errors;
    }
};

export default compose(connect(null, mapDispatchToProps), reduxForm(InviteEmployeesValidation))(InviteEmployees);
